import React, { useState } from 'react';
import { duckify, currentUser } from '../../utils/duckify';
import { blackbaudSkyConfig as blackbaudSkyConfigDuck } from '../../ducks';
import { Button } from 'react-bootstrap';
import FlashMessage from 'components/FlashMessage/FlashMessage';
import Placeholder from '../Placeholder';
import { apiFetch } from 'utils';
import { titleize } from 'utils/strings';
import '../styles/SubPageNavigation.scss';
import './styles/BlackbaudSkyConfig.scss';

const nxtDataTypes = ['accounts', 'projects', 'journals', 'transaction_codes'];
const schoolDataTypes = ['Grade Level', 'Phone Types', 'Address Type', 'Role', 'Checklist'];


const BlackbaudSkyConfig = ({ allDucksReady, blackbaudSkyConfig, currentUser, dispatch }) => {
  const [displayData, updateDisplayData] = useState({});
  // Handles which data a user can fetch from this page so the page doesn't become overwhelming
  const [showData, updateShowData] = useState('school');
  // Errors from the API get methods we use to fetch data
  const [errors, updateErrors] = useState('');
  const [fetching, updateFetching] = useState(false);

  const fetchData = (dataType, apiType, opts = {}) => {
    updateFetching(true);
    apiFetch.post({}, 'blackbaud_sky_config/get_data', {
      data_type: dataType,
      api_type: apiType,
      ...opts
    })
      .then((response) => {
        if (response.error) {
          updateErrors('Blackbaud Sky returned the following error: ' + (response.error_description || response.error));
        } else {
          updateDisplayData({
            ...displayData,
            [dataType]: response[dataType]['Message'] || response[dataType]
          });
        }
        updateFetching(false);
      })
      .catch((response) => {
        const responseJson = JSON.parse(response);
        updateErrors('Blackbaud Sky returned the following error: ' + (responseJson.error_description || responseJson.error));
        updateFetching(false);
      });
  };

  const SchoolData = () => {
    const [codeId, updateCodeId] = useState('');

    return <fieldset>
      <h2>Blackbaud School Data</h2>

      <p>
        <h3 style={{ paddingTop: '10px' }}>Student Data</h3>
        <p>
          <label>Student ID
            <input style={{ marginLeft: '10px' }} onChange={(e) => updateCodeId(e.target.value)}/></label>
        </p>
        <p>
          <Button disabled={fetching}
                  onClick={() => fetchData('student', 'school', { code_id: codeId })}>Get Student File</Button>
          {displayData['student'] && <DisplayTable dataObject={[displayData['student']]}/>}
        </p>
      </p>


      <p>
        <h3 style={{ paddingTop: '10px' }}>Term Data</h3>
        <p>
          <label>Term
            <input style={{ marginLeft: '10px' }} onChange={(e) => updateCodeId(e.target.value)}/></label>
        </p>
        <p>
          <Button disabled={fetching}
                  onClick={() => fetchData('term', 'school', { code_id: codeId })}>Get Term Data</Button>
          {displayData['term'] && <DisplayTable dataObject={displayData['term']}/>}
        </p>
      </p>


      <p>
        <h3 style={{ paddingTop: '10px' }}>Audit Data</h3>
        <p>
          <label>Role ID
            <input style={{ marginLeft: '10px' }} onChange={(e) => updateCodeId(e.target.value)}/></label>
        </p>
        <p>
          <Button disabled={fetching}
                  onClick={() => fetchData('audits', 'school', { code_id: codeId })}>Get Audits</Button>
          {displayData['audits'] && <DisplayTable dataObject={displayData['audits']}/>}
        </p>
      </p>

      {schoolDataTypes.map((dataType) => {
        return (<div>
          <h3 style={{ paddingTop: '10px' }}>{titleize(dataType)}</h3>
          {!displayData[dataType] &&
          <Button disabled={fetching} onClick={() => fetchData(dataType, 'school')}>Get {titleize(dataType)}</Button>}
          {displayData[dataType] && <DisplayTable dataObject={displayData[dataType]}/>}
        </div>);
      })
      }
    </fieldset>;
  };


// handles fetching data for feNXT
  const FeNxtData = () => {
    const [codeId, updateCodeId] = useState('');

    return <fieldset>
      <h2>FENXT Data</h2>
      Use the buttons below for fetching data relevant to building FENXT Exports
      {nxtDataTypes.map((dataType) => {
        return (<div>
          <h3 style={{ paddingTop: '10px' }}>{titleize(dataType)}</h3>
          {!displayData[dataType] &&
          <Button disabled={fetching} onClick={() => fetchData(dataType, 'nxt')}>Get {titleize(dataType)}</Button>}
          {displayData[dataType] && <DisplayTable dataObject={displayData[dataType]}/>}
        </div>);
      })
      }
      <p>
        <h3 style={{ paddingTop: '10px' }}>Transaction Code Values</h3>
        <p>
          <label>Enter Transaction Code Id:
            <input style={{ marginLeft: '10px' }} onChange={(e) => updateCodeId(e.target.value)}/></label>
        </p>
        <p>
          <Button disabled={fetching}
                  onClick={() => fetchData('transaction_code_values', { code_id: codeId })}>Get Transaction
            Code Values</Button>
          {displayData.transaction_code_values && <DisplayTable dataObject={displayData.transaction_code_values}/>}
        </p>
      </p>
    </fieldset>;
  };

  return (allDucksReady ?
    <div className={'form-horizontal'}>
      <fieldset>
        <legend>Blackbaud Sky Integration</legend>

        {errors.length > 0 && <FlashMessage type="danger" message={errors} dismissible={true}/>}

        {blackbaudSkyConfig.error_messages.length > 0 &&
        <FlashMessage type="danger" message={blackbaudSkyConfig.error_messages} dismissible={true}/>}

        {blackbaudSkyConfig.enabled && <div>
          <p>
            <a className="btn btn-primary" href={blackbaudSkyConfig.link}>Uninstall Plugin</a>
          </p>
          { currentUser.acl === 4  && <p>
            <label>Enable Blackbaud Two Way?
            <input id={'enable_blackbaud_two_way'} style={{ marginLeft: '6px' }} type={'checkbox'} defaultChecked={blackbaudSkyConfig.two_way_enabled} onChange={(e) => dispatch(blackbaudSkyConfigDuck.actions.update({two_way_enabled: e.target.checked}))}/>
            </label>
          </p>}
        </div>}


        {!blackbaudSkyConfig.enabled &&
        <div className={'mb-3 row'}>
          <h3>Plugin Installation Instructions</h3>
          <p><b className={'red'}>Prior to installing this plugin, please reach out to our support team to configure the data sync between Finalsite Enrollment and Blackbaud.</b></p>

          <p>In order to allow Finalsite Enrollment to push information to your Blackbaud products, the Finalsite
            Enrollment plugin must be
            installed by a user with the <b>Marketplace Admin</b> permission level.
            </p>
          <p>To install, please follow the instructions below: </p>
          <div className={'card card-body bg-light'}>
            <ol className={'sky-instructions'}>
              <li>Go to <a href={'https://app.blackbaud.com/marketplace'}> https://app.blackbaud.com/marketplace </a>
              </li>
              <li>Click <b>Manage</b></li>
              <li>Click <b>Connect App</b></li>
              <li>Enter the code shown here: <code>{blackbaudSkyConfig.application_code}</code> and choose Connect, then
                Close.
              </li>
              <li>Click the button to enable the plugin:
                <p>              <br/>
                  <a className="btn btn-primary" href={blackbaudSkyConfig.link}>Install Plugin</a></p></li>
            </ol>
          </div>
        </div>
        }

      </fieldset>

      {currentUser.acl === 4 && blackbaudSkyConfig.enabled && <React.Fragment>
        <legend>Blackbaud Sky Data Access (SuperAdmin Only)</legend>
        <ul className={'nav nav-pills flat-pill'}>
          <li onClick={() => updateShowData('school')} className={showData === 'school' ? 'active' : ''}><a href="#">School
            Data</a></li>
          <li onClick={() => updateShowData('nxt')} className={showData === 'nxt' ? 'active' : ''}><a href="#">FeNXT
            Data</a></li>
        </ul>
        {showData === 'nxt' && <FeNxtData/>}
        {showData === 'school' && <SchoolData/>}
      </React.Fragment>}
    </div>
    : <Placeholder.loading/>);


};


const DisplayTable = ({ dataObject }) => {
  // Some of these have the actual data under the value key, some under the top level key, so we need to check both
  const data = Object.keys(dataObject)
    .includes('value') ? dataObject.value : dataObject;
  return (<table className={'table table-striped'}>
    <thead>
    {Object.keys(data[0])
      .map((header) => <th style={{ padding: '10px' }}>{header}</th>)}
    </thead>
    <tbody>
    {data.map((object) => {
      return <tr>{Object.keys(object)
        .map((k) => <td>{JSON.stringify(object[k])}</td>)}</tr>;
    })}
    </tbody>
  </table>);
};


const mapDucksToProps = (props) => {
  return {
    currentUser,
    blackbaudSkyConfig: blackbaudSkyConfigDuck
  };
};

export default duckify(mapDucksToProps)(BlackbaudSkyConfig);

